<template>
  <div :style="{ padding: '12px', minHeight: '360px' }">
    <a-bread-crumb :crumbs="[{ 'path': 'resources', 'name': 'Resources'}]" />
    <a-skeleton active :loading="loading" :title="false" :paragraph="{ rows: 8, width: 800 }">
      <a-button
        type="primary"
        shape="round"
        @click="showDrawer"
        style="margin-top:10px;margin-bottom:30px;"
      >Create new resource</a-button>
    </a-skeleton>
    <a-skeleton active :loading="loading" :title="false" :paragraph="{ rows: 8, width: 800 }">
      <a-list
        :dataSource="allResources"
        itemLayout="horizontal"
        :pagination="pagination"
        :grid="{ size: 'middle'}"
      >
        <a-list-item slot="renderItem" slot-scope="resource" :rowKey="resource.uuid">
          <a
            @click="$router.push({ name: 'resourceEdit', params: { uuid: resource.uuid }})"
            slot="actions"
            style="color: rgba(0, 0, 0, 0.45) !important;"
          >
            <a-icon type="form" style="padding:5px;"></a-icon>Edit
          </a>
          <div class="extra" v-if="Array.isArray(resource.scopes) && resource.scopes.length">
            <b>Scopes</b>
            <ul>
              <li v-for="(k, index) in resource.scopes" :key="index"><a-tag style="margin-bottom: 2px;">{{k.permission}}</a-tag></li>
            </ul>
          </div>
          <a-list-item-meta
            class="clickable"
            @click="$router.push({ name: 'resourceEdit', params: { uuid: resource.uuid } })"
            :description="resource.description"
          >
            <a slot="title">
              <b>{{ resource.name }}</b>
            </a>
            <a-avatar
              slot="avatar"
              shape="square"
              :size="48"
              icon="api"
              style="background: #002e66;"
            />
          </a-list-item-meta>
        </a-list-item>
      </a-list>
    </a-skeleton>
    <a-create-resource v-if="!loading"/>
  </div>
</template>

<script>
import ACreateResource from "@/components/Drawer/ACreateResource";
export default {
  data() {
    return {
      loading: true,
      pagination: {
        onChange: page => {
          console.log(page);
        },
        pageSize: 10
      }
    };
  },
  methods: {
    success() {
      this.$message.success("Copied.", 5);
    },
    showDrawer() {
      this.$store.dispatch("ui/showDrawer", {
        drawer_name: "create_resource"
      });
    }
  },
  components: {
    ACreateResource,
  },
  computed: {
    allResources() {
      return this.$store.state.tenant.resources;
    }
  },

  beforeCreate: async function() {
    try {
      await this.$store.dispatch("tenant/getItems", {
        endpoint: "resources"
      });
      this.loading = false;
      try {
        await this.$store.cache.dispatch("tenant/getOptions", {
          endpoint: "resources"
        });
      } catch (error) {
        console.error(error);
      }
    } catch (error) {
      console.error(error);
      this.loading = false;
    }
  }
};
</script>

<style lang="css">
.resource-id {
  display: inline-block;
  width: 280px;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  text-align: center;
  border-style: dashed;
  background: white;
  padding: 5px;
  margin-left: 5px;
}

.ant-list-split .ant-list-item {
  border-bottom: 1px solid #e8e8e8 !important;
}

.ant-list-item-meta-avatar {
  padding-bottom: 5px;
}
.disabled {
  opacity: 0.7;
}
</style>
